var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"buttons":['cancel', 'save'],"large":"","title":"Cadastro de medicamento não padronizado"},on:{"save":function($event){return _vm.$refs.Form.save()}}},[_c('Form',{ref:"Form",attrs:{"items":_vm.items},on:{"save":_vm.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }